/**
 * Feedback sonore POS — bip court via Web Audio API.
 * Pas de fichier audio (marche hors-ligne), un seul AudioContext réutilisé
 * (Safari limite le nombre de contextes). Utilisé pour l'ajout au panier / scan.
 */

let audioCtx: AudioContext | null = null;

function getCtx(): AudioContext | null {
  try {
    const AudioCtx =
      window.AudioContext ||
      (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!AudioCtx) return null;
    if (!audioCtx) audioCtx = new AudioCtx();
    // Safari : le contexte démarre « suspended » jusqu'à un geste utilisateur.
    // L'ajout au panier vient d'un tap/scan (geste), donc resume() réussit.
    if (audioCtx.state === 'suspended') audioCtx.resume().catch(() => {});
    return audioCtx;
  } catch {
    return null;
  }
}

/** Bip court de confirmation (ajout panier, scan). */
export function playBeep(frequency = 880, durationMs = 80, volume = 0.15): void {
  const ctx = getCtx();
  if (!ctx) return;
  try {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.frequency.value = frequency;
    osc.type = 'square';
    gain.gain.value = volume;
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start();
    osc.stop(ctx.currentTime + durationMs / 1000);
  } catch {
    /* pas de feedback audio si bloqué */
  }
}
